import { Dialog, Button, DialogContent, DialogActions } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';



const useModalStyles = makeStyles((theme) => ({

    fontStyle :{fontWeight:'bold', fontFamily:'Times New Roman' },
    spaceStyle:{display:'flex', justifyContent:'space-between'},
    centerStyle:{textAlign:'center'},
    imageStyle:{width:"470px", height:"650px", float:"left"},
    contentStyle:{float:"left",  width:"450px"},

}));



export default function ImageModal({ open , handleClose, url}) {
    const classes = useModalStyles();

    return (
        <Dialog open={open} onClose={handleClose} >
            <DialogActions style={{justifyContent:"space-between"}}>

                  <Button onClick={handleClose} color="secondary" variant="outlined">
                    Fermer
                  </Button>
              </DialogActions>   

              <DialogContent>
                    <div className={classes.imageStyle} >
                          <img src={url} width="100%" height="100%" alt='...' />
                    </div>
              </DialogContent>
        </Dialog>
    )
}
